import {Routes} from '@angular/router'
import {adminAuthGuard, LoginComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {HOME_PATH, LOGIN_PATH} from './0-application/constants'

export default [
  {
    path: HOME_PATH,
    loadChildren: () => import('./3-home/routes'),
    canActivate: [adminAuthGuard]
  },
  {
    path: LOGIN_PATH,
    component: LoginComponent,
    title: 'Identifiering'
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: LOGIN_PATH
  },
  {
    path: '**',
    redirectTo: LOGIN_PATH
  }
] satisfies Routes
